import { render, staticRenderFns } from "./customer.main.vue?vue&type=template&id=0e03fa6e&scoped=true&"
import script from "./customer.main.vue?vue&type=script&lang=js&"
export * from "./customer.main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e03fa6e",
  null
  
)

export default component.exports